import { Component, inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UserService } from "../../services/user.service";
import { ConfirmResetPassRequestData } from "../../models/user.model";
import { CommonService } from "../../services/common.service";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent implements OnInit {
  @Input() set queryData(queryData: any) {
    if (queryData !== undefined) {
      this.queryParams = queryData;
    }
  }

  private _fb: FormBuilder = inject(FormBuilder);
  private _userService: UserService = inject(UserService);
  private _commonService: CommonService = inject(CommonService);

  form!: FormGroup;
  loading!: boolean;
  error!: boolean;
  errorMessage!: string;
  queryParams: any;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  success!: boolean;

  constructor() {
    this.formInitialize();
  }

  ngOnInit(): void {
  }

  formInitialize(): void {
    this.form = this._fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]]
    },{ validators: this._commonService.passwordsMatchValidator() });
  }

  onSubmit(): void {
    if (this.loading) return;

    this.error = false;
    this.loading = true;
    this.success = false;

    if (!this.form.valid) return;
    const formValue = this.form.value;

    const resetPassReqData: ConfirmResetPassRequestData = {
      new_password: formValue.password,
      token: this.queryParams.token,
      email: this.queryParams.email
    }

    this._userService.confirmResetPass(resetPassReqData).subscribe(result => {
      this.loading = false;
      this.success = true;
    }, error => {
      this.loading = false;
      this.error = true;

      if (error.status === 429) {
        this.errorMessage = 'Too Many Requests. Try late.'
      }
    })
  }

  togglePasswordVisibility(field: 'password' | 'confirmPassword') {
    if (field === 'password') {
      this.showPassword = !this.showPassword;
    } else if (field === 'confirmPassword') {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }
}
